<template>
  <div class="Routing">
    <OrderTable
      v-model="selection"
      :orders="releasedOrders"
      :cols="[
        'Wave',
        'Truck',
        'Dist',
        'Zone',
        'Account',
        'Type',
        'Order Notes',
        'Delivery Notes',
        'Address',
        'Qty',
        'Qty Scnd',
        'Invoices',
        'Status',
      ]"
      tab="routing"
    >
      <btn
        ref="downloadPicklabelRoute"
        type="primary"
        data-popover-trigger
        @click="togglePopover('downloadPicklabelRoute')"
      >
        {{ downloadPicklabelRoute.buttonText }}
      </btn>
      <btn
        ref="downloadPicksheetRoute"
        type="primary"
        data-popover-trigger
        @click="togglePopover('downloadPicksheetRoute')"
      >
        {{ downloadPicksheetRoute.buttonText }}
      </btn>
      <btn
        ref="downloadPacklabel"
        type="primary"
        data-popover-trigger
        @click="togglePopover('downloadPacklabel')"
      >
        {{ downloadPacklabel.buttonText }}
      </btn>
      <popover
        :target="$refs.downloadPacklabel"
        v-model="downloadPacklabel.showPopover"
        trigger="manual"
        placement="bottom"
      >
        <template slot="popover">
          <div style="margin: 10px 10px 0px 10px">
            <label>What kind of packlabel?</label>
            <select v-model="downloadPacklabel.template">
              <option value="sortedByWave">Sorted by wave</option>
              <option value="sortedByTruck">Sorted by truck</option>
              <option value="sortedByTruckAndZone">
                Sorted by truck and Zone
              </option>
            </select>
          </div>
          <div style="margin: 10px">
            <btn
              type="primary"
              :disabled="downloadPacklabel.requesting"
              @click="handleRequestPacklabel"
            >
              Request
            </btn>
            <btn @click="downloadPacklabel.showPopover = false">Close</btn>
          </div>
          <div
            v-if="downloadPacklabel.jobLinkText"
            style="margin: 0 10px 10px 10px"
          >
            <a
              v-if="downloadPacklabel.jobLink"
              :href="downloadPacklabel.jobLink"
              target="_blank"
              rel="noopener"
              >{{ downloadPacklabel.jobLinkText }}</a
            >
            <span v-else>{{ downloadPacklabel.jobLinkText }}</span>
          </div>
        </template>
      </popover>
      <btn
        ref="downloadPacksheet"
        type="primary"
        data-popover-trigger
        @click="togglePopover('downloadPacksheet')"
      >
        {{ downloadPacksheet.buttonText }}
      </btn>
      <popover
        :target="$refs.downloadPacksheet"
        v-model="downloadPacksheet.showPopover"
        trigger="manual"
        placement="bottom"
      >
        <template slot="popover">
          <div style="margin: 10px 10px 0px 10px">
            <label>What kind of packsheet?</label>
            <select v-model="downloadPacksheet.template">
              <option value="sortedByWave">Sorted by wave</option>
              <option value="sortedByTruck">Sorted by truck</option>
            </select>
          </div>
          <div style="margin: 10px">
            <btn
              type="primary"
              :disabled="downloadPacksheet.requesting"
              @click="handleRequestPacksheet"
            >
              Request
            </btn>
            <btn @click="downloadPacksheet.showPopover = false">Close</btn>
          </div>
          <div
            v-if="downloadPacksheet.jobLinkText"
            style="margin: 0 10px 10px 10px"
          >
            <a
              v-if="downloadPacksheet.jobLink"
              :href="downloadPacksheet.jobLink"
              target="_blank"
              rel="noopener"
              >{{ downloadPacksheet.jobLinkText }}</a
            >
            <span v-else>{{ downloadPacksheet.jobLinkText }}</span>
          </div>
        </template>
      </popover>
      <btn
        ref="requestBOLBundle"
        type="primary"
        data-popover-trigger
        @click="togglePopover('requestBOLBundle')"
        :class="requestBOLBundle.buttonClass"
      >
        {{ requestBOLBundle.buttonText }}
      </btn>
      <popover
        :target="$refs.requestBOLBundle"
        v-model="requestBOLBundle.showPopover"
        trigger="manual"
        placement="bottom"
      >
        <template slot="popover">
          <div v-if="trucks.length === 0">
            <p>
              You can only request a BOL Bundle on this tab after at least one
              order has been assigned to a truck.
            </p>
            <p>
              Try again once you've exported routes from Dispatch Track and
              refreshed the data here.
            </p>
          </div>
          <form v-else @submit.prevent="handleRequestBOLBundleClick">
            <div style="margin: 10px 10px 0px 10px">
              <label>Select a truck:</label>
              <br />
              <select v-model="requestBOLBundle.form.truck">
                <option v-for="truck in trucks" :key="truck" :value="truck">
                  {{ truck }}
                </option>
              </select>
              <br />
              <label>Include invoices?</label>
              <input
                type="checkbox"
                v-model="requestBOLBundle.form.includeInvoices"
              />
              <br />
              <label>Split bundle into multiple files?</label>
              <input
                type="checkbox"
                v-model="requestBOLBundle.form.shouldZip"
              />
            </div>
            <div style="margin: 10px">
              <btn
                type="primary"
                native-type="submit"
                :disabled="requestBOLBundle.requesting"
                >Request</btn
              >
              <btn @click="requestBOLBundle.showPopover = false">Close</btn>
            </div>
            <div
              v-if="requestBOLBundle.jobLinkText"
              style="margin: 0 10px 10px 10px"
            >
              <a
                v-if="requestBOLBundle.jobLink"
                :href="requestBOLBundle.jobLink"
                target="_blank"
                rel="noopener"
                >{{ requestBOLBundle.jobLinkText }}</a
              >
              <span v-else>{{ requestBOLBundle.jobLinkText }}</span>
            </div>
          </form>
        </template>
      </popover>
      <popover
        :target="$refs.downloadPicklabelRoute"
        v-model="downloadPicklabelRoute.showPopover"
        trigger="manual"
        placement="bottom"
      >
        <template slot="popover">
          <div style="margin: 10px 10px 0px 10px">
            <label>Select account:</label>
            <select v-model="downloadPicklabelRoute.account">
              <option
                v-for="account in accounts"
                :key="account"
                :value="account"
              >
                {{ account }}
              </option>
            </select>
          </div>
          <div style="margin: 10px">
            <btn
              type="primary"
              :disabled="downloadPicklabelRoute.requesting"
              @click="handleRequestPicklabelRoute"
            >
              Request
            </btn>
            <btn @click="downloadPicklabelRoute.showPopover = false">Close</btn>
          </div>
          <div
            v-if="downloadPicklabelRoute.jobLinkText"
            style="margin: 0 10px 10px 10px"
          >
            <a
              v-if="downloadPicklabelRoute.jobLink"
              :href="downloadPicklabelRoute.jobLink"
              target="_blank"
              rel="noopener"
              >{{ downloadPicklabelRoute.jobLinkText }}</a
            >
            <span v-else>{{ downloadPicklabelRoute.jobLinkText }}</span>
          </div>
        </template>
      </popover>
      <popover
        :target="$refs.downloadPicksheetRoute"
        v-model="downloadPicksheetRoute.showPopover"
        trigger="manual"
        placement="bottom"
      >
        <template slot="popover">
          <div style="margin: 10px 10px 0px 10px">
            <label>Select account:</label>
            <select v-model="downloadPicksheetRoute.account">
              <option
                v-for="account in accounts"
                :key="account"
                :value="account"
              >
                {{ account }}
              </option>
            </select>
          </div>
          <div style="margin: 10px">
            <btn
              type="primary"
              :disabled="downloadPicksheetRoute.requesting"
              @click="handleRequestPicksheetRoute"
            >
              Request
            </btn>
            <btn @click="downloadPicksheetRoute.showPopover = false">Close</btn>
          </div>
          <div
            v-if="downloadPicksheetRoute.jobLinkText"
            style="margin: 0 10px 10px 10px"
          >
            <a
              v-if="downloadPicksheetRoute.jobLink"
              :href="downloadPicksheetRoute.jobLink"
              target="_blank"
              rel="noopener"
              >{{ downloadPicksheetRoute.jobLinkText }}</a
            >
            <span v-else>{{ downloadPicksheetRoute.jobLinkText }}</span>
          </div>
        </template>
      </popover>
    </OrderTable>
    <OrderSelection v-model="selection">
      <template slot-scope="{ doAction }">
        <btn
          type="danger"
          @click="doAction('Removing', removeFromDispatchTrack)"
        >
          Remove from Dispatch Track
        </btn>
        <btn
          type="primary"
          @click="doAction('Uploading Receipts for', uploadDeliveryReceipt)"
        >
          Upload Delivery Receipts
        </btn>
      </template>
    </OrderSelection>
  </div>
</template>

<script>
import { requestBOLBundle, requestReport, jobsUrl, jobUrl } from '@/api';
import {
  removeOrdersFromDispatchTrack,
  uploadDeliveryReceiptFromDispatchTrack,
} from '@/queries';
import orderBy from 'lodash.orderby';

import { formatGraphQLError } from '@/utils';
import singleOpenPopovers from '@/mixins/singleOpenPopovers';

export default {
  name: 'Routing',
  props: ['pickDate', 'orders'],
  data() {
    return {
      selection: [],
      requestBOLBundle: {
        showPopover: false,
        buttonText: 'BOL Bundle',
        buttonClass: ['btn', 'btn-primary'],
        requesting: false,
        jobLink: null,
        jobLinkText: null,
        form: {
          truck: null,
          includeInvoices: true,
          shouldZip: true,
        },
      },
      downloadPacksheet: {
        showPopover: false,
        buttonText: 'Packsheet',
        buttonClass: ['btn', 'btn-primary'],
        requesting: false,
        jobLink: null,
        jobLinkText: null,
        // Must be one of the select's options above — the zone variant was
        // dropped from the packsheet popover (wineapp cutover), so defaulting
        // to it left the select blank and downloaded the wrong report.
        template: 'sortedByTruck',
      },
      downloadPacklabel: {
        showPopover: false,
        buttonText: 'Packlabel',
        buttonClass: ['btn', 'btn-primary'],
        requesting: false,
        jobLink: null,
        jobLinkText: null,
        template: 'sortedByTruckAndZone',
      },
      downloadPicklabelRoute: {
        showPopover: false,
        buttonText: 'Picklabel',
        account: null,
        requesting: false,
        jobLink: null,
        jobLinkText: null,
      },
      downloadPicksheetRoute: {
        showPopover: false,
        buttonText: 'Picksheet',
        account: null,
        requesting: false,
        jobLink: null,
        jobLinkText: null,
      },
    };
  },
  watch: {
    // A prior request's job link refers to the form as it was submitted —
    // clear it when the fields change so it can't mislabel the next request.
    'requestBOLBundle.form': {
      deep: true,
      handler() {
        this.requestBOLBundle.jobLink = null;
        this.requestBOLBundle.jobLinkText = null;
      },
    },
    'downloadPicklabelRoute.account'() {
      this.downloadPicklabelRoute.jobLink = null;
      this.downloadPicklabelRoute.jobLinkText = null;
    },
    'downloadPicksheetRoute.account'() {
      this.downloadPicksheetRoute.jobLink = null;
      this.downloadPicksheetRoute.jobLinkText = null;
    },
    'downloadPacksheet.template'() {
      this.downloadPacksheet.jobLink = null;
      this.downloadPacksheet.jobLinkText = null;
    },
    'downloadPacklabel.template'() {
      this.downloadPacklabel.jobLink = null;
      this.downloadPacklabel.jobLinkText = null;
    },
    // Both requests send pickDate, and cache-first keeps this component
    // mounted across date switches — a link from another date is stale too.
    pickDate() {
      var self = this;
      [
        'requestBOLBundle',
        'downloadPicklabelRoute',
        'downloadPicksheetRoute',
        'downloadPacksheet',
        'downloadPacklabel',
      ].forEach(function (k) {
        self[k].jobLink = null;
        self[k].jobLinkText = null;
      });
    },
  },
  computed: {
    releasedOrders() {
      return this.orders.filter((order) => order.wave && order.wave.releasedAt);
    },
    trucks() {
      const trucks = this.releasedOrders.reduce((trucks, { truck }) => {
        if (truck && !trucks[truck]) {
          trucks[truck] = true;
        }
        return trucks;
      }, {});
      return Object.keys(trucks).sort();
    },
    accounts() {
      const seen = {};
      this.releasedOrders.forEach((order) => {
        const dc = order.dispatchTrackDistributionCenter;
        if (dc) {
          seen[dc] = true;
        }
      });
      delete seen['Willcall']; // Willcall will never be downloadable
      return Object.keys(seen).sort();
    },
  },
  mixins: [
    singleOpenPopovers([
      'downloadPicklabelRoute',
      'downloadPicksheetRoute',
      'downloadPacklabel',
      'downloadPacksheet',
      'requestBOLBundle',
    ]),
  ],
  methods: {
    // Shared: request a report on wineapp's job system and reflect the
    // outcome on the popover's state (jobLink/jobLinkText/requesting).
    async requestReportJob(state, params) {
      state.requesting = true;
      state.jobLink = null;
      state.jobLinkText = null;
      try {
        const res = await requestReport(params);
        if (res.existing) {
          // An equivalent job is already running for this user.
          state.jobLink = jobUrl(res.job_receipt_id);
          state.jobLinkText = 'Job In Progress';
        } else {
          state.jobLink = jobsUrl();
          state.jobLinkText = 'Requested — view in Jobs';
        }
      } catch (e) {
        state.jobLink = null;
        state.jobLinkText = 'Request failed — try again.';
      } finally {
        state.requesting = false;
      }
    },
    // Route picklabel → wineapp job system (one PDF per truck for the account,
    // bundled into a zip). Sends pick_date + account; the result lands on /#jobs.
    async handleRequestPicklabelRoute() {
      const route = this.downloadPicklabelRoute;
      if (!route.account) {
        return;
      }
      await this.requestReportJob(route, {
        report: 'picklabel',
        template: 'sortedByRoute',
        pickDate: this.pickDate,
        account: route.account,
      });
    },
    async handleRequestPicksheetRoute() {
      const route = this.downloadPicksheetRoute;
      if (!route.account) {
        return;
      }
      await this.requestReportJob(route, {
        report: 'picksheet',
        template: 'sortedByRoute',
        pickDate: this.pickDate,
        account: route.account,
      });
    },
    async handleRequestPacksheet() {
      await this.requestReportJob(this.downloadPacksheet, {
        report: 'packsheet',
        template: this.downloadPacksheet.template,
        pickDate: this.pickDate,
      });
    },
    async handleRequestPacklabel() {
      await this.requestReportJob(this.downloadPacklabel, {
        report: 'packlabel',
        template: this.downloadPacklabel.template,
        pickDate: this.pickDate,
      });
    },
    async handleRequestBOLBundleClick() {
      if (!this.requestBOLBundle.form.truck) {
        return;
      }
      // Guard double-submit: the popover stays open (to show the job link), so
      // without this a second click would fire a second request. Mirrors
      // handleRequestPicklabelRoute.
      if (this.requestBOLBundle.requesting) {
        return;
      }
      this.requestBOLBundle.requesting = true;
      this.requestBOLBundle.jobLink = null;
      this.requestBOLBundle.jobLinkText = null;

      try {
        const direction = this.requestBOLBundle.form.shouldZip ? 'asc' : 'desc';
        const orders = this.releasedOrders.filter(
          (order) => order.truck === this.requestBOLBundle.form.truck
        );
        const order_ids = orderBy(orders, ['truck', 'stop'], ['asc', direction])
          .map((order) => order.skId)
          .join(',');

        // Send the structured request fields; wineapp derives the download
        // filename + email subject from these (keeps the job's params clean and
        // drives the Pick Date / Truck / Include Invoices / Split Bundle activity).
        const { success, existing, jobReceiptId } = await requestBOLBundle({
          order_ids,
          pick_date: this.pickDate,
          truck: this.requestBOLBundle.form.truck,
          include_invoices: this.requestBOLBundle.form.includeInvoices,
          should_zip: this.requestBOLBundle.form.shouldZip,
        });

        if (!success) {
          this.requestBOLBundle.jobLink = null;
          this.requestBOLBundle.jobLinkText = 'Request failed — try again.';
        } else if (existing) {
          // An equivalent bundle is already running for this user.
          this.requestBOLBundle.jobLink = jobUrl(jobReceiptId);
          this.requestBOLBundle.jobLinkText = 'Job In Progress';
        } else {
          this.requestBOLBundle.jobLink = jobsUrl();
          this.requestBOLBundle.jobLinkText = 'Requested — view in Jobs';
        }
      } catch (e) {
        this.requestBOLBundle.jobLink = null;
        this.requestBOLBundle.jobLinkText = 'Request failed — try again.';
      } finally {
        this.requestBOLBundle.requesting = false;
      }
    },
    async removeFromDispatchTrack(orders) {
      try {
        await this.$apollo.mutate({
          mutation: removeOrdersFromDispatchTrack,
          variables: {
            input: {
              ids: orders.map((order) => order.id),
            },
          },
        });
      } catch (e) {
        // Throw to delegate back to OrderSelection catch block
        throw formatGraphQLError(e);
      }
    },
    async uploadDeliveryReceipt(orders) {
      try {
        for (let order of orders) {
          await this.$apollo.mutate({
            mutation: uploadDeliveryReceiptFromDispatchTrack,
            variables: {
              input: {
                skOrderNum: order.skOrderNum,
                b2c: order.routedBy === 'b2c',
              },
            },
          });
        }
      } catch (e) {
        // Throw to delegate back to OrderSelection catch block
        throw formatGraphQLError(e);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Routing.vue